import _defineProperty from "/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _asyncToGenerator from "/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
var __jsx = React.createElement;
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import _regeneratorRuntime from "/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
/* eslint-disable */
import React, { useState, useCallback, useEffect, useRef, useLayoutEffect } from 'react';
import { GoogleMap, useJsApiLoader, Marker, InfoWindow, Autocomplete, MarkerClusterer, MarkerF } from '@react-google-maps/api';
import { getOrderedLocations, buildGoogleDirections } from './Helper';
import Heading from '../../atoms/Heading';
import Para from '../../atoms/Para';
import Anchor from '../../atoms/Anchor';
import styled, { useTheme } from 'styled-components';
import styles from './GoogleMapsMultiLocations.style';
import ListComponent from './ListComponentMultiLocations';
import { convertPhoneFormat } from '../../../utils/utilityFunction';
import { isMobile } from 'react-device-detect';
import Address from '../../atoms/Address/Address';
import { FaCar, FaMapMarkedAlt } from 'react-icons/fa';
import Calendar from '../../../static/images/icons/Calendar';
var GoogleMapsBlock = styled.section.withConfig({
  componentId: "sc-877jo4-0"
})(["", ";"], styles);
import { getGoogleStaticMapsApiKey } from '../../../utils/utilityFunction';
var GoogleMapsMultiLocations = function GoogleMapsMultiLocations(props) {
  var _selectedLocation$res, _searchInput$current;
  /** These values are defined in Contentful under the Location Blade - Multiple content type */
  /** locationInformation toggles elements to a location. Location Name, Address, Phone, etc. */
  var locationInformation = props.locationInformation || [];
  /** variation defines Interactive Map Left or Interactive Map Right. The other options in this dropdown in Contentful are used for card locations. This really should have been broken up into 2 modules. */
  var variation = props.variation || [];
  /** mapFilterSearch toggles the search bar */
  var mapFilterSearch = props.mapFilterSearch || [];
  /** cardsCta toggles the search bar, defined in Contentful under the Location Blade - Multiple content type */
  var cardsCta = props.cardsCta || [];
  var theme = useTheme();
  /** ref to the list component on the right */
  var listContent = useRef();
  var _useState = useState(false),
    showLocationWindow = _useState[0],
    setShowLocationWindow = _useState[1];
  /** activeMarker is the same as selectedLocation, but holds and formats the lat and long */
  var _useState2 = useState({}),
    activeMarker = _useState2[0],
    setActiveMarker = _useState2[1];
  /** the object created when a user clicks on a marker/location */
  var _useState3 = useState({}),
    selectedLocation = _useState3[0],
    setSelectedLocation = _useState3[1];
  /** topOfSelectedCard defines the location to scroll to in the ListComponent */
  var _useState4 = useState(),
    topOfSelectedCard = _useState4[0],
    setTopOfSelectedCard = _useState4[1];
  /** used to define the center point when the map loads */
  var mapCenter = {
    lat: activeMarker.lat || 38.5,
    lng: activeMarker.lng || -98.0
  };
  var _useState5 = useState(4),
    mapZoom = _useState5[0],
    setMapZoom = _useState5[1];
  /** map object used by Google to refresh the map layout */
  var _useState6 = useState(null),
    map = _useState6[0],
    setMap = _useState6[1];
  var _useState7 = useState(null),
    defaultMapBounds = _useState7[0],
    setDefaultMapBounds = _useState7[1];
  /** default locations passed to component via Contentful */
  var _props$locations = props.locations,
    locations = _props$locations === void 0 ? [] : _props$locations;
  /** filtered locations based on locationSearch lat lng */
  var _useState8 = useState(locations),
    filteredLocations = _useState8[0],
    setFilterLocations = _useState8[1];
  /** sets the lat and long of the center point of the geolocation from the browser or the search input field */
  var _useState9 = useState({
      lat: '',
      lng: ''
    }),
    locationSearch = _useState9[0],
    setLocationSearch = _useState9[1];
  /** set when user allows location in thier browser  */
  var _useState10 = useState(false),
    isGeolocationActive = _useState10[0],
    setIsGeolocationActive = _useState10[1];
  /** the auto fill component that helps users finde thier location: city, neighborhood.*/
  var _useState11 = useState(null),
    autoPlace = _useState11[0],
    setAutoPlace = _useState11[1];
  /** location input ref */
  var searchInput = useRef({});
  /** used to define the default search radius, leaving useState in case we need to add UI control */
  var _useState12 = useState('150'),
    selectedRadius = _useState12[0],
    setSelectedRadius = _useState12[1];
  var _useState13 = useState(false),
    toggleMap = _useState13[0],
    setToggleMap = _useState13[1];
  var _useState14 = useState(true),
    isListLoading = _useState14[0],
    setIsListLoading = _useState14[1];
  var _useState15 = useState(true),
    mapProps = _useState15[0],
    setMapProps = _useState15[1];
  /** used to toggle console logs */
  var testing = false;
  /** used to establish */
  var _useState16 = useState(['places']),
    libraries = _useState16[0],
    setLibraries = _useState16[1];
  /** establish api connection for NVA google account api key */
  var _useJsApiLoader = useJsApiLoader({
      id: 'google-map-script',
      googleMapsApiKey: getGoogleStaticMapsApiKey(),
      libraries: libraries
    }),
    isLoaded = _useJsApiLoader.isLoaded;
  var autoCompleteOptions = {
    componentRestrictions: {
      country: ['us', 'ca']
    }
  };
  function getDefaultLocationsBounds() {
    if (map && locations) {
      var geolocationBounds = new window.google.maps.LatLngBounds();
      locations.map(function (item) {
        var latLng = new window.google.maps.LatLng(item.yextDisplayCoordinate.latitude, item.yextDisplayCoordinate.longitude);
        geolocationBounds.extend(latLng);
      });
      return geolocationBounds;
    }
  }

  /** onLoad get the useres browser location and filter locations based on location by expanding the geto location bounds of all locations */
  var onLoad = useCallback(function (map) {
    if (testing) console.log('%conLoad map filteredLocations', 'color:green; font-size:16px');
    if (testing) console.dir(filteredLocations);
    if (filteredLocations.length > 0) {
      var bounds;
      var geolocationBounds = new window.google.maps.LatLngBounds();
      filteredLocations && filteredLocations.map(function (item) {
        var latLng = new window.google.maps.LatLng(item.yextDisplayCoordinate.latitude, item.yextDisplayCoordinate.longitude);
        geolocationBounds.extend(latLng);
      });
      bounds = geolocationBounds;
      map.fitBounds(bounds);
      setMap(map);
      setIsListLoading(false);
    } else {
      setMap(map);
    }
    if (testing) console.log('%c end onLoad map filteredLocations', 'color:green; font-size:16px');
  }, [JSON.stringify(filteredLocations)]);
  var zoomOut = function zoomOut() {
    var bounds = defaultMapBounds;
    if (!bounds) {
      bounds = getDefaultLocationsBounds();
      setDefaultMapBounds(bounds);
    }
    map === null || map === void 0 ? void 0 : map.fitBounds(bounds);
  };

  /** from a selectedLocation lat and lng, finds locations within the selectedRadius. Fancy math, not sure of origins. Seems to work fine.*/
  var getLocationsWithInRadius = function getLocationsWithInRadius(lat, lng, radius) {
    if (testing) console.log('%cgetLocationsWithInRadius ', 'color:orange; font-size:16px');
    var p = 0.017453292519943295;
    var c = Math.cos;
    var radiusMiles = radius * 1.60934;
    var kmToMile = 12742;
    if (lat && lng && radius && locations && locations.length > 0) {
      return locations.filter(function (location) {
        //if (testing) console.log(`location ${location.address.region}`);
        //if (testing) console.dir(location);
        var a = 0.5 - c((location.yextDisplayCoordinate.latitude - lat) * p) / 2 + c(lat * p) * c(location.yextDisplayCoordinate.latitude * p) * (1 - c((location.yextDisplayCoordinate.longitude - lng) * p)) / 2;
        if (testing) console.log('%cend getLocationsWithInRadius ', 'color:orange; font-size:16px');
        return radiusMiles > kmToMile * Math.asin(Math.sqrt(a));
      });
    }
  };
  /** set the initial filteredLocation with the props passed to the component via Contentful */
  useLayoutEffect(function () {
    if (testing) console.log('%c useLayoutEffect set initial locations', 'color:#D2691E; font-size:16px');
    if (testing) console.log("props");
    if (testing) console.dir(props);
    if (props) {
      setDefaultMapBounds(getDefaultLocationsBounds());
      getOrderedLocations;
      setFilterLocations(getOrderedLocations(props.locations, false));
    }
    if (testing) console.log('%c end useLayoutEffect set initial locations', 'color:#D2691E; font-size:16px');
  }, []);

  /** used to find the top of the list card that has been selected as the activeMarker. This was coupled with setting the initial Locations and triggered on any change. It was causing a reset of the list component that was not deried. Created a separate useLayoutEffect from the one above. */
  useLayoutEffect(function () {
    if (testing) console.log('%c useLayoutEffect topOfSelectedCard, listContent', 'color:blue; font-size:16px');
    if (testing) console.log("--listContent");
    if (testing) console.dir(listContent);
    if (testing) console.log("listContent.current ".concat(listContent.current));
    if (testing) console.log("topOfSelectedCard ".concat(topOfSelectedCard));

    /** scroll list to top of selected card */
    if (listContent && listContent.current && topOfSelectedCard) {
      if (testing) console.log('%c We are scrolling, Mr White.', 'color:pink; font-size:16px');
      var listComponentRect = listContent.current.getBoundingClientRect();
      listContent.current.scrollTop = listContent.current.scrollTop + (topOfSelectedCard - listComponentRect.top);
      if (testing) console.log('%c We scrolled, Jesse.', 'color:pink; font-size:16px');
    }
    if (testing) console.log('%c end useLayoutEffect topOfSelectedCard, listContent', 'color:blue; font-size:16px');
  }, [topOfSelectedCard, listContent]);

  /** when a new location is entered finds locations that are within the selectedRadius. If no locations have been located, it will try again by multiplying the selecteRadius by attempt(index) to widen the search area. Also fires when selectedRadius is updated, which is currently not setup in the UI. */
  useEffect(function () {
    if (testing) console.log('%c locationSearch, selectedRadius', 'color:#6495ED; font-size:16px');
    if (testing) console.log("selectedRadius");
    if (testing) console.log(selectedRadius);
    if (testing) console.log("locationSearch");
    if (testing) console.dir(locationSearch);
    function func(_x) {
      return _func.apply(this, arguments);
    }
    function _func() {
      _func = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(attemp) {
        var apiData;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (testing) console.log("attemp");
                if (testing) console.dir(attemp);
                setIsListLoading(true);
                if (locationSearch.lat !== '') {
                  apiData = getLocationsWithInRadius(locationSearch.lat, locationSearch.lng, selectedRadius * attemp);
                  if (testing) console.log("apiData");
                  if (testing) console.dir(apiData);
                  if (!(apiData !== null && apiData !== void 0 && apiData.length) && attemp > 3) {
                    if (testing) console.log('%c No locations within radius', 'color:red; font-size:16px');
                    setFilterLocations(locations);
                  } else if (!(apiData !== null && apiData !== void 0 && apiData.length) && attemp <= 3) {
                    func(attemp + 1);
                  } else {
                    if (testing) console.log('%c Found locations within radius', 'color:green; font-size:16px');
                    if (testing) console.log("Locations within radius ".concat(apiData.length));
                    setFilterLocations(apiData);
                  }
                  setIsListLoading(false);
                }
              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));
      return _func.apply(this, arguments);
    }
    func(1);
    if (testing) console.log('%cend locationSearch, selectedRadius', 'color:#6495ED; font-size:16px');
  }, [locationSearch, selectedRadius]);
  /** when the activeMarker is set, zoom into the location */
  useEffect(function () {
    if (testing) console.log("activeMarker ".concat(activeMarker.lat, " ").concat(activeMarker.lng, " "));
    if (activeMarker && activeMarker.lat && activeMarker.lng) {
      setMapZoom(15);
    }
  }, [activeMarker]);
  useEffect(function () {
    if (testing) console.log('%cselectedLocation, filteredLocations, showLocationWindow, toggleMap', 'color:red; font-size:16px');
    if (testing) console.dir(selectedLocation);
    if (map) {
      if (testing) console.log("Map true Mr White.");
      var geolocationBounds = new window.google.maps.LatLngBounds();
      //if (testing) console.dir(geolocationBounds);
      if (testing) console.log("activeMarker ".concat(JSON.stringify(activeMarker)));
      if (testing) console.log("A new location has been selected");
      if (!isEmpty(selectedLocation) && activeMarker.lat && activeMarker.lng) {
        if (testing) console.log("activeMarker has been selected, Calculate the geo bounds from the activeMarker");
        var SelectedLatLng = new window.google.maps.LatLng(activeMarker.lat, activeMarker.lng);
        geolocationBounds.extend(SelectedLatLng);
        map.fitBounds(geolocationBounds);
        setMap(map);
      } else if (filteredLocations && filteredLocations.length > 0 && searchInput && searchInput.current.value !== '') {
        // Enters only when the searchbox is used to zoom in
        // TODO: this should on an event listener instead of useEffect but it's not working. Requires investigation
        if (testing) console.log("activeMarker has NOT been selected get the bounding box of the list of filtered locations");
        filteredLocations && filteredLocations.map(function (item) {
          if (filteredLocations.length < 10) {
            if (testing) console.log("filtered location");
            if (testing) console.dir(item);
          }
          var latLng = new window.google.maps.LatLng(item.yextDisplayCoordinate.latitude, item.yextDisplayCoordinate.longitude);
          geolocationBounds.extend(latLng);
        });
        map.fitBounds(geolocationBounds);
        setMap(map);
      }
      setTimeout(function () {
        return setIsListLoading(false);
      }, 500);
    }
    if (testing) console.log('%cend selectedLocation', 'color:red; font-size:16px');
  }, [selectedLocation, filteredLocations, showLocationWindow, toggleMap]);
  var onUnmount = useCallback(function (map) {
    setMap(null);
  }, []);
  /** Resets the map to the default view */
  var onMapClicked = useCallback(function () {
    if (testing) console.log('%conMapClicked showLocationWindow', 'color:green; font-size:16px');
    if (showLocationWindow) {
      closeMarker();
    }
    if (testing) console.log('%cend onMapClicked showLocationWindow', 'color:green; font-size:16px');
  }, [showLocationWindow]);
  /**this resets the locationSearch for the user defined location in the search input */
  var onPlaceChanged = function onPlaceChanged() {
    if (testing) console.log('%conPlaceChanged searchInput.current.value =', 'color:green; font-size:16px');
    if (testing) console.log(" ".concat(searchInput.current.value));
    setIsListLoading(true);
    setShowLocationWindow(false);
    setMapProps(true);
    setSelectedLocation({});
    var text = searchInput.current.value;
    if (text) {
      var geocoding = new window.google.maps.Geocoder();
      geocoding && geocoding.geocode && geocoding.geocode({
        address: text
      }, function (results, status) {
        if (status === 'OK') {
          if (results[0].types[0] === 'country') {
            setLocationSearch({
              lat: '',
              lng: ''
            });
          } else {
            setLocationSearch(results && results[0] && {
              lat: results[0].geometry.location.lat(),
              lng: results[0].geometry.location.lng()
            });
          }
        } else {
          setLocationSearch({
            lat: '',
            lng: ''
          });
        }
      });
    } else {
      if (autoPlace !== null) {
        setShowLocationWindow(false);
        setActiveMarker({});
        if (autoPlace.getPlace() && autoPlace.getPlace().name === '') {
          setLocationSearch({
            lat: '',
            lng: ''
          });
        } else {
          setLocationSearch(autoPlace && autoPlace.getPlace() && {
            lat: autoPlace.getPlace().geometry.location.lat(),
            lng: autoPlace.getPlace().geometry.location.lng()
          });
        }
      }
    }
    if (testing) console.log('%cend onPlaceChanged searchInput.current.value =', 'color:green; font-size:16px');
  };

  /** this handles the zoom in to the selected location, sets the activeMarker and selectedLocation information. Both have the same lat and lng, but formatted differently for the google maps api */
  var openMarker = function openMarker(e, index, place, latitude, longitude) {
    var _place$reservationUrl;
    if (testing) console.log("openMarker ".concat(e, " ").concat(index, " ").concat(latitude, " ").concat(longitude));
    if (testing) console.log((_place$reservationUrl = place.reservationUrl) === null || _place$reservationUrl === void 0 ? void 0 : _place$reservationUrl.url);
    setShowLocationWindow(true);
    if (isMobile) {
      /** hides map ui that is in the way in mobile view*/
      setMapProps(false);
    }
    setActiveMarker({
      lat: latitude || e.latLng.lat(),
      lng: longitude || e.latLng.lng()
    });
    setSelectedLocation({
      index: index,
      name: place.name,
      businessType: place === null || place === void 0 ? void 0 : place.c_businessType,
      address: place.address,
      websitePhone: place.websitePhone,
      mainPhone: place.mainPhone,
      websiteUrl: place.websiteUrl,
      lat: latitude || e.latLng.lat(),
      lng: longitude || e.latLng.lng(),
      reservationUrl: place.reservationUrl
    });
  };
  /** closes Marker information and zooms back out to see all locations*/
  var closeMarker = function closeMarker() {
    if (testing) console.log("---closeMarker");
    if (searchInput) {
      searchInput.current.value = '';
    }
    setActiveMarker({});
    setShowLocationWindow(false);
    setMapProps(true);
    setFilterLocations(locations);
    if (testing) console.dir(selectedLocation);
    if (!isEmpty(selectedLocation)) {
      setSelectedLocation({});
    }
    if (testing) console.dir(searchInput);
    if (searchInput && searchInput.current.value === '') {
      setMapZoom(4);
    } else {
      onPlaceChanged();
    }
    zoomOut();
  };
  /** when a map cluster is selected this sets the locationSearch, which refilters the locations in the ListComponent */
  var setClusterList = function setClusterList(e) {
    if (testing) console.log("setClusterList");
    //
    if (testing) console.dir(e);
    if (testing) console.dir(e.center.lat());
    if (testing) console.dir(e.center.lng());
    setMapZoom(2);
    setLocationSearch({
      lat: e.center.lat(),
      lng: e.center.lng()
    });
  };
  function isEmpty(obj) {
    return Object.keys(obj).length === 0;
  }
  var _onZoomChanged = function onZoomChanged(newZoom) {
    if (testing) console.log("onZoomChanged mapZoom ".concat(mapZoom, " newZoom ").concat(newZoom));
    if (newZoom < 8) {
      setFilterLocations(locations);
      setActiveMarker({});
      setShowLocationWindow(false);
    }
  };
  var autocompleOnLoad = useCallback(function () {
    setAutoPlace(autoPlace);
  }, [autoPlace]);
  var handleInputClean = function handleInputClean() {
    setActiveMarker({});
    setShowLocationWindow(false);
    setMapProps(true);
    setSelectedLocation({});
    setMapZoom(4);
  };
  return isLoaded ? __jsx(GoogleMapsBlock, {
    className: "nva-maps-multi-location"
  }, __jsx("div", {
    className: "map-container"
  }, mapFilterSearch.includes('Search Only') && __jsx("div", {
    className: "nva-maps-multi-location__filters filters"
  }, __jsx(Heading, {
    HeadingType: "h2",
    className: "nva-maps-multi-location__filters-header heading_five caption"
  }, "Search for a Location Nearest You:"), __jsx("div", {
    className: "nva-maps-multi-location__filters-auto-complete autoComplete"
  }, __jsx(Autocomplete, {
    onLoad: autocompleOnLoad,
    onPlaceChanged: onPlaceChanged,
    options: autoCompleteOptions,
    className: "auto-complete"
  }, __jsx("form", {
    className: "nva-maps-multi-location__search-form search-form"
  }, __jsx("input", {
    ref: searchInput,
    onChange: function onChange(_e) {
      if (searchInput.current.value === '') {
        setIsListLoading(true);
        setTimeout(function () {
          setLocationSearch({
            lat: '',
            lng: ''
          });
          handleInputClean();
          setFilterLocations(locations);
        }, 0);
      }
    },
    onKeyDown: function onKeyDown(e) {
      if (e.key == 'Enter') e.preventDefault();
    },
    id: "searchbox",
    placeholder: "City/State/ZIP",
    title: "City/State/ZIP",
    type: "search",
    autoComplete: "off"
  }), __jsx("button", {
    id: "search-button",
    type: "button",
    onClick: onPlaceChanged
  }, __jsx("span", null, "Search")))))), __jsx("div", {
    className: "side-bar-map ".concat(variation === 'Interactive Map Left' && 'left')
  }, __jsx("div", {
    className: "nva-maps-multi-location__map-view map-view"
  }, __jsx(GoogleMap, {
    id: "google-map",
    onLoad: onLoad,
    onUnmount: onUnmount,
    defaultCenter: mapCenter,
    defaultZoom: mapZoom,
    onClick: onMapClicked,
    onZoomChanged: function onZoomChanged(e) {
      _onZoomChanged(map.getZoom());
    },
    options: {
      maxZoom: 18,
      minZoom: 4,
      styles: [{
        featureType: 'poi',
        stylers: [{
          visibility: 'off'
        }]
      }, {
        featureType: 'transit',
        elementType: 'labels.icon',
        stylers: [{
          visibility: 'off'
        }]
      }, {
        featureType: 'all',
        elementType: 'geometry.fill',
        stylers: [{
          color: '#ffffff'
        }]
      }, {
        featureType: 'all',
        elementType: 'geometry.stroke',
        stylers: [{
          color: '#b2b3b3'
        }]
      }, {
        featureType: 'water',
        elementType: 'geometry.fill',
        stylers: [{
          color: '#c8d7d4'
        }]
      }, {
        featureType: 'administrative',
        elementType: 'geometry.stroke',
        stylers: [{
          color: '#b2b3b3'
        }]
      }],
      streetViewControl: mapProps,
      fullscreenControl: mapProps,
      clickableIcons: false,
      mapTypeControl: mapProps
    }
  }, filteredLocations && __jsx(MarkerClusterer, {
    onClick: setClusterList,
    averageCenter: true,
    options: {
      max: 20,
      styles: [{
        width: 40,
        height: 40,
        textSize: 15,
        textColor: '#fff',
        className: 'clusterIcon',
        url: ''
      }]
    }
  }, function (clusterer) {
    return __jsx(React.Fragment, null, locations && locations.map(function (place, index) {
      var _theme$button;
      return __jsx(MarkerF, {
        key: index,
        position: {
          lat: place.yextDisplayCoordinate.latitude,
          lng: place.yextDisplayCoordinate.longitude
        },
        icon: {
          path: 'M50,10.417c-15.581,0-28.201,12.627-28.201,28.201c0,6.327,2.083,12.168,5.602,16.873L45.49,86.823 c0.105,0.202,0.21,0.403,0.339,0.588l0.04,0.069l0.011-0.006c0.924,1.278,2.411,2.111,4.135,2.111c1.556,0,2.912-0.708,3.845-1.799 l0.047,0.027l0.179-0.31c0.264-0.356,0.498-0.736,0.667-1.155L72.475,55.65c3.592-4.733,5.726-10.632,5.726-17.032 C78.201,23.044,65.581,10.417,50,10.417z M49.721,52.915c-7.677,0-13.895-6.221-13.895-13.895c0-7.673,6.218-13.895,13.895-13.895 s13.895,6.222,13.895,13.895C63.616,46.693,57.398,52.915,49.721,52.915z',
          fillColor: "var(--sc-button--bg-color-hero, ".concat(theme === null || theme === void 0 ? void 0 : (_theme$button = theme.button) === null || _theme$button === void 0 ? void 0 : _theme$button.backgroundColorHero, ")"),
          fillOpacity: 1,
          strokeWeight: 0,
          rotation: 0,
          scale: 0.5,
          anchor: new window.google.maps.Point(50, 75)
        },
        onClick: function onClick(e) {
          setIsListLoading(true);
          var lat = place.yextDisplayCoordinate.latitude;
          var _long = place.yextDisplayCoordinate.longitude;
          openMarker(e, index, place, lat, _long);
          setSelectedLocation(_objectSpread(_objectSpread({}, place), {}, {
            index: index
          }));
        },
        clusterer: clusterer,
        style: ({
          color: '#333'
        }, {
          fill: '#aeaeae'
        }),
        id: "marker"
      });
    }));
  }), showLocationWindow && activeMarker && activeMarker.lat && activeMarker.lng && selectedLocation && __jsx(InfoWindow, {
    position: activeMarker,
    onCloseClick: function onCloseClick(e) {
      setIsListLoading(true);
      closeMarker();
    }
  }, __jsx("div", {
    className: "infoWindow"
  }, (locationInformation === null || locationInformation === void 0 ? void 0 : locationInformation.includes('Location Name')) && __jsx(Heading, {
    HeadingType: "h3",
    className: "titleSelectedPlace"
  }, selectedLocation.name), __jsx("button", {
    className: 'closeButton',
    onClick: function onClick(e) {
      closeMarker();
    }
  }, "X"), selectedLocation.address && __jsx(Address, {
    addressLine1: (locationInformation === null || locationInformation === void 0 ? void 0 : locationInformation.includes('Address')) && selectedLocation.address.line1,
    addressLine2: (locationInformation === null || locationInformation === void 0 ? void 0 : locationInformation.includes('Address')) && selectedLocation.address.line2,
    city: (locationInformation === null || locationInformation === void 0 ? void 0 : locationInformation.includes('City')) && selectedLocation.address.city,
    state: (locationInformation === null || locationInformation === void 0 ? void 0 : locationInformation.includes('Region')) && selectedLocation.address.region,
    postalCode: (locationInformation === null || locationInformation === void 0 ? void 0 : locationInformation.includes('Address')) && selectedLocation.address.postalCode
  }), (selectedLocation.c_websitePhone || selectedLocation.mainPhone) && cardsCta.includes('Phone') && __jsx("div", {
    className: "phone-class"
  }, __jsx("span", null, "Phone: "), __jsx(Anchor, {
    title: "Phone: ".concat(convertPhoneFormat(selectedLocation.c_websitePhone || selectedLocation.mainPhone)),
    onClick: function onClick(e) {
      return e.stopPropagation();
    },
    href: "tel:".concat(convertPhoneFormat(selectedLocation.c_websitePhone || selectedLocation.mainPhone)),
    to: "tel:".concat(convertPhoneFormat(selectedLocation.c_websitePhone || selectedLocation.mainPhone)),
    className: "external-links"
  }, __jsx("span", null, convertPhoneFormat(selectedLocation.c_websitePhone || selectedLocation.mainPhone)))), selectedLocation.c_textPhone && cardsCta.includes('Text') && __jsx("div", {
    className: "phone-class"
  }, __jsx("span", null, "Text: "), __jsx(Anchor, {
    title: "Phone: ".concat(convertPhoneFormat(selectedLocation.c_textPhone)),
    onClick: function onClick(e) {
      return e.stopPropagation();
    },
    href: "tel:".concat(convertPhoneFormat(selectedLocation.c_textPhone)),
    to: "tel:".concat(convertPhoneFormat(selectedLocation.c_textPhone)),
    className: "external-links"
  }, __jsx("span", null, convertPhoneFormat(selectedLocation.c_textPhone)))), selectedLocation && selectedLocation.websiteUrl && selectedLocation.websiteUrl.url && __jsx("div", {
    className: "footer-content"
  }, __jsx("div", {
    className: "view-page-view-map-container"
  }, __jsx(Anchor, {
    title: "Visit Site",
    "aria-label": "Visit Site " + selectedLocation.name,
    onClick: function onClick(e) {
      return e.stopPropagation();
    },
    to: selectedLocation.websiteUrl.url,
    styleType: "primary-anchor",
    className: "map-btn",
    target: "_blank",
    rel: "noopener noreferrer",
    tabIndex: "0"
  }, __jsx("span", null, __jsx("svg", {
    stroke: "currentColor",
    fill: "currentColor",
    strokeWidth: "0",
    viewBox: "0 0 512 512",
    className: "fa-icon",
    height: "1em",
    width: "1em",
    xmlns: "http://www.w3.org/2000/svg"
  }, __jsx("path", {
    d: "M444.52 3.52L28.74 195.42c-47.97 22.39-31.98 92.75 19.19 92.75h175.91v175.91c0 51.17 70.36 67.17 92.75 19.19l191.9-415.78c15.99-38.39-25.59-79.97-63.97-63.97z"
  }))), __jsx("span", null, "Visit Site")), selectedLocation && selectedLocation.reservationUrl && selectedLocation.reservationUrl.url && cardsCta.includes('Book') && __jsx(React.Fragment, null, __jsx(Anchor, {
    title: "Make Reservation",
    "aria-label": "Make a Reservation for " + selectedLocation.name,
    onClick: function onClick(e) {
      return e.stopPropagation();
    },
    styleType: "primary-anchor",
    className: "map-btn",
    to: (_selectedLocation$res = selectedLocation.reservationUrl) === null || _selectedLocation$res === void 0 ? void 0 : _selectedLocation$res.url,
    target: "_blank",
    rel: "noopener noreferrer"
  }, __jsx("span", {
    className: "icon"
  }, __jsx(Calendar, {
    className: "calendar-icon-happy"
  })), "Book Now")), cardsCta.includes('Map') && __jsx(Anchor, {
    title: "Get Directions",
    "aria-label": "Get directions for " + selectedLocation.name,
    target: "_blank",
    to: buildGoogleDirections(selectedLocation.address, searchInput === null || searchInput === void 0 ? void 0 : (_searchInput$current = searchInput.current) === null || _searchInput$current === void 0 ? void 0 : _searchInput$current.value),
    styleType: "primary-anchor",
    className: "map-btn",
    rel: "noopener noreferrer"
  }, __jsx("span", {
    className: "icon"
  }, __jsx(FaMapMarkedAlt, {
    className: "fa-icon"
  })), "Directions"))))))), __jsx("div", {
    className: "nva-maps-multi-location__side-bar side-bar"
  }, __jsx("div", {
    className: "list-content",
    ref: listContent
  }, !isListLoading && filteredLocations && getOrderedLocations(filteredLocations).map(function (item, index) {
    var _searchInput$current2;
    return __jsx(ListComponent, {
      locationInformation: locationInformation,
      key: index,
      toggleMap: toggleMap,
      setTopOfSelectedCardToParent: setTopOfSelectedCard,
      itemIndex: index,
      name: item.name,
      item: item,
      selectedClinic: selectedLocation,
      setSelectedClinic: setSelectedLocation,
      address: item.address,
      inputAddress: searchInput === null || searchInput === void 0 ? void 0 : (_searchInput$current2 = searchInput.current) === null || _searchInput$current2 === void 0 ? void 0 : _searchInput$current2.value,
      website: (item === null || item === void 0 ? void 0 : item.websiteUrl) && (item === null || item === void 0 ? void 0 : item.websiteUrl.url),
      listOnClick: function listOnClick(e) {
        e.stopPropagation();
        setIsListLoading(true);
        var latitude = item.yextDisplayCoordinate.latitude;
        var longitude = item.yextDisplayCoordinate.longitude;
        openMarker(null, index, item, latitude, longitude);
        setSelectedLocation(_objectSpread(_objectSpread({}, item), {}, {
          index: index
        }));
      },
      coordinates: item.c_googleMyBusinessCID,
      reservationLink: item.reservationUrl && item.reservationUrl.url,
      phoneNumber: item.c_websitePhone || item.mainPhone,
      sms: item.c_textPhone,
      fax: item.fax,
      distance: typeof (item === null || item === void 0 ? void 0 : item.distance) !== 'undefined' ? item.distance : null,
      duration: typeof (item === null || item === void 0 ? void 0 : item.duration) !== 'undefined' ? item.duration : null,
      collapseButtonDisplay: true,
      businessType: item.c_businessType,
      setToggle: function setToggle() {
        setToggleMap(!toggleMap);
      }
    });
  }) || isListLoading && __jsx("div", {
    className: "loading"
  }, __jsx("p", null, "Loading List...")), !isListLoading && filteredLocations.length <= 0 && __jsx("div", {
    className: "no-locations-text"
  }, __jsx("p", null, "No locations are within this area. Please update your location or filters."))))))) : '';
};
export default /*#__PURE__*/React.memo(GoogleMapsMultiLocations);